import { Button } from "@jsq/ds/core";
import { useEntityClientWizard } from "../context";
import { useCreateCase } from "./useCreateCase";

export const ReviewFooter = () => {
  const { goBack } = useEntityClientWizard();
  const { handleCreateCase, submitting, programsLoading } = useCreateCase();

  return (
    <>
      <Button variant="neutral" onClick={goBack}>
        Back
      </Button>
      <Button
        variant="primary"
        onClick={() => void handleCreateCase()}
        disabled={submitting || programsLoading}
      >
        Create case
      </Button>
    </>
  );
};
